import ClaimContactPerson from './ClaimContactPerson';

export default ClaimContactPerson;
